import ImageCommon from "../image/image";
import {
  convertPhoneZero,
  formatWorkingDays,
  wrapperRouterPush,
} from "@/src/util/util";
import { Col, Row } from "antd";
import Image from "next/image";
import "./work-place.scss";
import { Divider } from "antd";
import StarRatings from "react-star-ratings";
import iconLocation from "../../../public/icon/icon-location-new.svg";
import iconTime from "../../../public/icon/icon-time-new.svg";
import iconPhone from "../../../public/icon/icon-phone-new.svg";
import iconWeb from "../../../public/icon/icon-website-new.svg";
import { useRouter } from "next/navigation";

const WorkPlace = ({ detailClinic }) => {
  const workday = detailClinic?.workday?.map((item) => {
    return {
      id: item.weekday.id,
      name: item.weekday.name,
    };
  });

  const router = useRouter();
  const addressClinic = detailClinic?.address[0];
  const totalRating =
    detailClinic?.rating_overview?.overall_average?.toFixed(1);
  return (
    <>
      {detailClinic ? (
        <Row className="wp-WorkPlace">
          <Col xs={24} sm={8} md={7} lg={5} xl={6} className="wp-logo-clinic">
            <ImageCommon data={detailClinic.image[0]} style={"logo-clinic"} />
          </Col>
          <Col
            xs={24}
            sm={16}
            md={17}
            lg={19}
            xl={18}
            className="wp-info-clinic"
          >
            <div
              className="mb name-clinic"
              onClick={() => {
                wrapperRouterPush(router, `/phong-kham/${detailClinic?.slug}`);
              }}
            >
              {detailClinic.name}
            </div>
            <div className="mb">
              <span className="flex-center">
                <Image
                  src={iconLocation}
                  alt="icon-location"
                  width={36}
                  height={22}
                />
                {addressClinic?.detail_address
                  ? addressClinic.detail_address
                  : addressClinic?.district?.name +
                    " - " +
                    addressClinic?.province?.name}
              </span>
            </div>
            <div className="mb flex-center">
              <span className="totalRating">
                {totalRating == 0.0 ? 0 : totalRating}
              </span>
              <span>
                <StarRatings
                  rating={totalRating ? Number(totalRating) : 0}
                  numberOfStars={1}
                  starDimension="24px"
                  starRatedColor="#ffe140"
                  starEmptyColor="#ffe23f"
                />
              </span>
              <Divider type="vertical" className="customer-divider" />
              <span>
                {detailClinic?.rating_overview?.number_of_ratings} Đánh giá{" "}
                <Divider type="vertical" className="customer-divider" />
              </span>
              <span>{detailClinic.total_contact} Người đặt lịch</span>
            </div>
            <div className="mb flex-center">
              <Image
                src={iconTime}
                alt="icon-work-time"
                width={36}
                height={22}
              />
              <span>
                <strong>Thời gian làm việc:&nbsp;&nbsp;</strong>
                {detailClinic?.time_note
                  ? detailClinic.time_note
                  : `${detailClinic?.time_start} - ${detailClinic?.time_end}${
                      workday?.length > 0
                        ? `, ${formatWorkingDays(workday)}`
                        : ""
                    }`}
              </span>
            </div>
            <div className="mb flex-center">
              <Image src={iconPhone} alt="icon-phone" width={36} height={22} />
              <span>
                <strong>Liên hệ:&nbsp;&nbsp;</strong>
                {/* {detailClinic?.phone[0]?.phone_number
                  ? convertPhoneZero(detailClinic?.phone[0]?.phone_number)
                  : ""} */}
                {detailClinic?.user?.user_agreements &&
                detailClinic?.user?.user_agreements[0]?.status == "ACTIVE"
                  ? detailClinic?.phone[0] &&
                    detailClinic?.phone[0]?.phone_number
                    ? convertPhoneZero(detailClinic?.phone[0]?.phone_number)
                    : "_"
                  : "0869554535"}
              </span>
            </div>
            {detailClinic?.website &&
              detailClinic?.user?.user_agreements &&
              detailClinic?.user?.user_agreements[0]?.status == "ACTIVE" && (
                <span className="wp-website flex-center">
                  <Image
                    src={iconWeb}
                    width={36}
                    height={22}
                    alt="Website icon"
                  />
                  <strong>Website:&nbsp;&nbsp;</strong>
                  {detailClinic?.website}
                </span>
              )}
          </Col>
        </Row>
      ) : (
        <div
          style={{
            color: "#2a3467",
            display: "flex",
            justifyContent: "center",
            fontSize: "16px",
            margin: "12px 0px",
          }}
        >
          Chưa có thông tin
        </div>
      )}
    </>
  );
};

export default WorkPlace;
